import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CommonService } from "../../shared/common.service";
import { AuthService } from "../auth.service";
import { Router } from "@angular/router";
import { HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";
import { MatSnackBar } from "@angular/material";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  isLogin: boolean = true;
  isOpt: boolean = false;
  validOTP: boolean = false;
  loginForm: FormGroup;
  signUpForm: FormGroup;
  forgotPasswordForm: FormGroup;
  forgetPass: boolean = true;
  useMobile: any;
  formSubmitted: boolean = false;
  errorMsg: string = "Ok";
  headers = [];
  adminUser: boolean = true;
  clubUser: boolean = false;
  LoginFlag: boolean = true;
  ResetFlag: boolean = false;
  Loginmessage: string = "";
  isLoading: boolean = false;
  isMobile: boolean = true;
  otp: any;
  optToken: any;
  emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  phoneNumber: any;
  email: any;
  errorCount: number = 0;
  selectedFile: File;
  CACDocumentUrl: any;
  countryCodes = [];
  mobileCode = "+258";
  countryFlag = "";
  constructor(
    private fb: FormBuilder,
    private authServices: AuthService,
    private commonService: CommonService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.initialiseForms();
    this.getCountry();
    localStorage.clear();
  }
  initialiseForms() {
    this.loginForm = this.fb.group({
      userName: [
        "",
        [Validators.required, Validators.pattern(this.emailPattern)],
      ],
      password: ["", [Validators.required]],
    });
    this.signUpForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: [null, [Validators.required, Validators.minLength(6)]],
      mobile: ["", [Validators.required, Validators.minLength(10)]],
      name: ["", [Validators.required]],
    });
    this.forgotPasswordForm = this.fb.group({
      newPassword: ["", [Validators.required]],
      confirmPassword: ["", [Validators.required]],
    });
  }

  inputNumber(event) {
    let mobile = this.signUpForm.value.mobile;
    let first = mobile.charAt(0);
    if (first == "0") {
      this.signUpForm.controls["mobile"].setValidators([
        Validators.minLength(10),
        Validators.required,
        ,
        Validators.maxLength(11),
      ]);
      this.signUpForm.controls["mobile"].updateValueAndValidity();
    } else {
      this.signUpForm.controls["mobile"].setValidators([
        Validators.minLength(9),
        Validators.required,
        ,
      ]);
      this.signUpForm.controls["mobile"].updateValueAndValidity();
    }
  }

  public inputValidator(event: any) {
    //console.log(event.target.value);
    const pattern = /^[0-9]*$/;
    //let inputChar = String.fromCharCode(event.charCode)
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^a-zA-Z]/g, "");
      // invalid character, prevent input
    }
  }
  navigateLogin(value: any) {
    if (value == "login") {
      this.isLogin = false;
      this.isOpt = false;
      this.loginForm.reset();
      this.signUpForm.reset();
      this.forgotPasswordForm.reset();
    }
    if (value == "signup") {
      this.isLogin = true;
      this.isOpt = false;
      this.loginForm.reset();
      this.signUpForm.reset();
      this.forgotPasswordForm.reset();
    }
    if (value == "otp") {
      this.isOpt = true;
    }
    if (value == "back") {
      this.isLogin = false;
      this.isOpt = false;
    }
    if (value == "mobileNumber") {
      this.isLogin = true;
      this.isOpt = false;
      this.isForget = false;
      this.newpassword = false;
      this.loginForm.reset();
      this.signUpForm.reset();
      this.forgotPasswordForm.reset();
    }
  }

  loginFN() {
    this.router.navigate(["main/trips-management/view-trips"]);
  }

  onOtpChange(event): void {
    if (event) {
      this.otp = event;
      if (this.otp.length == 4) {
        this.validOTP = true;
      } else {
        this.validOTP = false;
      }
    }
  }
  login() {
    this.formSubmitted = true;
    if (this.loginForm.valid) {
      let req = {
        email: this.loginForm.controls["userName"].value,
        password: this.loginForm.controls["password"].value,
      };
      this.isLoading = true;
      this.authServices.validateLogin(req).subscribe(
        (res: HttpResponse<any>) => {
          this.isLoading = false;
          if ((res["message"] = "Success")) {
            this.commonService.setStorage(
              "token",
              res.headers.get("Authorization")
            );
            let userData = this.commonService.getUser();
            localStorage.setItem("Upddl", JSON.stringify(res.body.data));
            if (res.body.data["status"] !== "active") {
              localStorage.setItem("UpdSt", "JkIIC");
              localStorage.setItem("hhppt", res.body.data.operatorId);
              this.router.navigate(["main/stop/"]);
            } else {
              localStorage.setItem("UpdSt", "Jkkpp");
              this.router.navigate(["main/stop/"]);
            }
          } else {
          }
        },
        (err) => {
          this.isLoading = false;
        }
      );
    }
  }

  // onlyNumberKey(event) {
  //   return event.charCode == 8 || event.charCode == 0
  //     ? null
  //     : event.charCode >= 48 && event.charCode <= 57;
  // }
  onlyNumberKey(event: KeyboardEvent) {
    const allowedCharacters = [
      "+",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
    ];

    const inputChar = String.fromCharCode(event.charCode);

    return allowedCharacters.includes(inputChar);
  }
  onlyAlphabets(e) {
    return (
      (e.charCode > 64 && e.charCode < 91) ||
      (e.charCode > 96 && e.charCode < 123) ||
      e.charCode == 32 ||
      e.charCode == 45
    );
  }
  navigatetoHome() {
    // window.open("http://Maap.com.ng/","_self")
  }

  OperatorSubmit() {
    this.isLoading = true;
    let request = this.signUpForm.value;
    request["mobile"] = this.mobileCode + this.signUpForm.value.mobile;
    request["otpToken"] = this.optToken;
    this.authServices.saveOperator(request).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["body"]["message"] == "Success") {
          this.commonService.setStorage(
            "token",
            res.headers.get("Authorization")
          );
          let userData = this.commonService.getUser();
          localStorage.setItem("UpdSt", "JkIIC");
          localStorage.setItem("Upddl", JSON.stringify(res.body.data));
          this.router.navigate(["main/account/detail"]);

          this.signUpForm.reset();
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  verifyOperator(value: any) {
    this.isLoading = true;

    let request = {
      mobile: this.mobileCode + this.signUpForm.value.mobile,
      email: this.signUpForm.value.email,
    };

    this.authServices.verifyOperator(request).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.generateOPT("signup");
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  onFileChanged(event) {
    this.isLoading = true;
    this.selectedFile = event.target.files[0];

    this.authServices.uploadImage(this.selectedFile).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] === "Success") {
          this.CACDocumentUrl = res.data.url;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  request: any = "";
  userScreen: any;
  generateOPT(value) {
    this.isLoading = true;

    if (value == "forget") {
      this.request = {
        mobile: this.mobileCode + this.useMobile,
        type: "OFP",
      };
    }
    if (value == "signup") {
      this.request = {
        mobile: this.mobileCode + this.signUpForm.value.mobile,
        type: "OR",
      };
    }

    this.isLoading = false;
    this.authServices.createOTP(this.request).subscribe(
      (res) => {
        console.log(res, "opt Response.");
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.isOpt = true;
          if (value == "forget") {
            this.validOTP = false;
            this.userScreen = "forget";
          }
          if (value == "signup") {
            this.validOTP = false;
            this.userScreen = "signup";
          }
          this.forgetPass = false;

          this.mobileSubString();
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        console.log(err, "opt Response. Error");
        this.isLoading = false;
      }
    );
  }
  submitForgetPassword() {
    this.isLoading = true;
    if (
      this.forgotPasswordForm.controls["confirmPassword"].value !=
      this.forgotPasswordForm.controls["newPassword"].value
    ) {
      this._snackBar.open("New password and Confirm password is not same", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["success"],
      });
      this.isLoading = false;
      return;
    }

    let request = {
      otpToken: this.optToken,
      mobile: this.mobileCode + this.useMobile,
      newPassword: this.forgotPasswordForm.value.confirmPassword,
    };

    this.isLoading = false;
    this.authServices.forgetPassword(request).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.isOpt = false;
          this.isLogin = true;
          this.isForget = false;
          this.forgetPass = false;
          this.newpassword = false;
          this.useMobile = "";
          this.forgotPasswordForm.reset();
          this._snackBar.open(
            "Password changed successfully! , Please Login",
            "",
            {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            }
          );
          //  this.mobileSubString();
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        console.log(err, "opt Response. Error");
        this.isLoading = false;
      }
    );
  }
  newpassword: boolean = false;
  req: any = "";
  verifyOPT(value) {
    this.isLoading = true;
    if (value == "login") {
      this.req = {
        mobile: this.mobileCode + this.signUpForm.value.mobile,
        //  "email": this.signUpForm.value.email,
        otp: parseInt(this.otp),
        type: "OR",
      };
    }

    if (value == "forget") {
      this.req = {
        mobile: this.mobileCode + this.useMobile,
        //  "email": this.signUpForm.value.email,
        otp: parseInt(this.otp),
        type: "OFP",
      };
    }

    this.authServices.verifyOTP(this.req).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.optToken = res.data.token;
          if (value == "forget") {
            this.newpassword = true;
            this.isOpt = false;
            this.forgetPass = false;
            this.isLogin = false;
            this.isForget = false;
          } else {
            this.OperatorSubmit();
          }
          // this.submitForgetPassword();
          //  this.OperatorSubmit();
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        if (this.errorCount == 2) {
          this.navigateLogin("signup");
        }
        this.errorCount = this.errorCount + 1;
        this.isLoading = false;
      }
    );
  }
  mobileSubString() {
    let length = this.signUpForm.value.mobile.length;
    let mobile = this.signUpForm.value.mobile;
    let email = this.signUpForm.value.email;
    let emailLengh = this.signUpForm.value.email.length;
    this.phoneNumber =
      mobile.substring(0, 3) + "***" + mobile.substring(length - 4, length);
    this.email =
      email.substring(0, 5) +
      "*****" +
      email.substring(emailLengh - 4, emailLengh);
  }

  submitOperator() {
    if (this.signUpForm.valid) {
      this.verifyOperator("signup");
    }
  }
  getCountry() {
    this.authServices.getCountryCode().subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.countryCodes = res.data.countryList;
          this.updateFlag();
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        console.log(err, "opt Response. Error");
        this.isLoading = false;
      }
    );
  }
  updateFlag() {
    this.countryCodes.forEach((element) => {
      if (element["mobileCode"] === this.mobileCode) {
        this.countryFlag = element["flagIcon"];
      }
    });
  }
  isForget: boolean = false;
  forgetPassword() {
    this.isForget = true;
    this.isLogin = false;
  }
  show: boolean = false;
  password() {
    this.show = !this.show;
  }
  show2: boolean = false;
  password2() {
    this.show2 = !this.show2;
  }
}
